<template>
    <div class="vue-root">

        <template v-if="!success && generalErrors !== null && generalErrors.length > 0">
            <slot name="general-errors">
                <div class="error-message">
                    {{ generalErrorMessage }}
                </div>
            </slot>
        </template>

        <form v-if="Object.keys(formValues).length > 0"
              ref="form"
              :class="[ formClass, { 'webform--floating-labels' :  floatingLabels, 'webform--success' : success}]"
              class="form webform row"
              enctype="multipart/form-data"
              method="post"
              novalidate
        >

            <input
                :value="path"
                name="path"
                type="hidden">
            <input
                :value="identifier"
                name="id"
                type="hidden">
            <component
                :is="component(item)"
                v-for="item in structure"
                :key="item.items[0].data.id"
                :btn-label="btnLabel"
                :errors="errors"
                :form-values="formValues"
                :general-errors="generalErrors"
                :item="item.type === 'formitem' ? item.items[0] : item"
                :values="values"
                @submit="submit"
                @update-form-value="updateFormValue"/>
            <input v-for="(dup, index) in duplicateFields" :id="getIdByUniqlabel(dup.target)" :key="index"
                   v-model="formValues[ dup.source ]" :name="getIdByUniqlabel(dup.target)" type="hidden"/>
        </form>
    </div>
</template>

<script>
import Input from "./elements/Input.vue";
import Button from "./elements/Button.vue";
import Select from "./elements/Select.vue";
import Radio from "./elements/Radio.vue";
import Checkbox from "./elements/Checkbox.vue";
import Html from "./elements/Html.vue";
import Instruction from "./elements/Instruction.vue";
import Terms from "./elements/Terms.vue";
import Scale from "./elements/Scale.vue";
import Numericscale from "./elements/Numericscale.vue";
import File from "./elements/File.vue";
import FormSection from "./elements/FormSection.vue";
import eventBus from "../formeditor/util/EventBus";
import Paymentmethod from "./elements/Paymentmethod.vue";
import Shippingmethod from "./elements/Shippingmethod.vue";
import Address from "./elements/Address.vue";
import Country from "./elements/Country.vue";

export default {
    name: 'VueForm',
    inheritAttrs: false,
    components: {
        Input,
        Button,
        Select,
        Radio,
        Checkbox,
        Html,
        Instruction,
        Terms,
        Scale,
        Numericscale,
        File,
        FormSection,
        Paymentmethod,
        Shippingmethod,
        Address,
        Country
    },
    props: {
        formId: {
            type: Number
        },
        structure: {
            type: [Object, Array]
        },
        floatingLabels: {
            type: Boolean,
            default: false
        },
        callbackSuccess: {
            type: Function,
            default: undefined
        },
        prefill: {
            type: Object
        },
        path: {
            type: String
        },
        basePath: {
            type: String
        },
        csrfToken: {
            type: String
        },
        identifier: {
            type: String
        },
        successText: {
            type: String
        },
        controllerAction: {
            type: String
        },
        graphqlQuery: {
            type: String
        },
        graphqlQueryArgs: {
            type: Object
        },
        duplicateFields: {
            type: Array,
            default: () => []
        },
        inputSubmitHook: {
            type: Function
        },
        btnLabel: {
            type: String
        },
        clearOnSuccess: {
            type: Boolean,
            default: false
        },
        generalErrorMessage: {
            type: String,
            default: ''
        },
        formClass: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            errors: {},
            success: false,
            values: {}, // store selected values for checkboxes, radios and selects
            generalErrors: {},
            formValues: {},
            typeCast: {}
        };
    },
    computed: {
        filteredStructure() {
            return this.structure.filter(item => !item.items[0].data.skipRendering)
        }
    },
    mounted() {
        eventBus.$on('setValue', (key, value) => {
            this.$set(this.values, key, value);
        });


        for (const item of this.structure) {
            if (item.type !== 'formsection') {
                const {
                    uniqlabel: key,
                    typecast,
                    view,
                    default: defaultVal,
                    match_prefill_key: matchPrefillKey,
                    answeroptions,
                } = item.items?.[0]?.data || {};

                if (typecast) {
                    this.typeCast[key] = typecast;
                }

                let value

                // set defaults value from structure input or radio / checkbox
                if (['checkbox', 'radio'].includes(view)) {
                    const findDefault = answeroptions.find(option => option.is_default)
                    if (findDefault) {
                        value = findDefault.value
                    }
                } else if (defaultVal) {
                    value = defaultVal
                }
                // replace value from matched key: salutationCode => salutation
                if (this.prefill) {
                    if (matchPrefillKey) {
                        value = this.prefill[matchPrefillKey]
                    } else {
                        value = this.prefill[key]
                    }
                }

                if (!value) {
                    // if checkbox
                    // ignore if value is integer and 0, because of radio value 1 / 0
                    if (Number.isInteger(value) === false) {
                        if (view === 'checkbox' && answeroptions.length === 1) {
                            // set model as string if only one checkbox, if multiple use array
                            value = ''
                        } else {
                            value = this.defaultValueByType(view)
                        }
                    }
                }

                this.formValues = {...this.formValues, [key]: value};
            } else {
                for (const innerItem of item.items) {

                    const {uniqlabel: key, view, default: defaultVal} = innerItem.data;
                    let value
                    if (defaultVal) {
                        value = defaultVal
                    } else {
                        value = this.prefill && this.prefill[key] ? this.prefill[key] : this.defaultValueByType(view)
                    }
                    this.formValues = {...this.formValues, [key]: value};
                }
            }
        }
    },
    methods: {
        getIdByUniqlabel(uniqlabel) {
            const target = this.structure.find(item => item?.items?.[0]?.data?.uniqlabel === uniqlabel);
            return target?.items?.[0]?.data?.id;
        },
        updateFormValue(ident, value) {
            this.$set(this.formValues, ident, value)
        },
        defaultValueByType(type) {
            switch (type) {
                case 'checkbox':
                    return []
                default:
                    return ''
            }
        },
        component(item) {
            let view = '';

            if (item.type === 'formitem') {
                view = item.items[0].data.view;
            } else {
                view = 'FormSection';
            }
            return view.charAt(0).toUpperCase() + view.slice(1);
        },
        matchErrorsWithCustomMessages(errors) {
            const {structure, formValues} = this;
            const objErrors = {};

            for (const {type, items} of structure) {
                if (type !== 'formitem') continue;
                const {data: itemData} = items?.[0];
                const {uniqlabel: key, mandatory, mandatory_warning: mandatoryMessage, customerrormessage} = itemData;
                const [errorMessage = ''] = errors[key] ?? [];
                if (!errorMessage) continue;
                if (mandatory && !formValues[key]) {
                    objErrors[key] = mandatoryMessage || errorMessage;
                } else if (customerrormessage && formValues[key]) {
                    objErrors[key] = customerrormessage || errorMessage;
                } else {
                    objErrors[key] = errorMessage;
                }
            }
            return objErrors;
        },
        async submit() {
            const form = new FormData(this.$refs.form);
            const md5 = require('md5');

            let action = this.basePath;
            let body = form;
            let headers = {
                'X-CSRF-Token': this.csrfToken,
                'X-Requested-With': 'XMLHttpRequest',
            };

            body.append(md5('webFormId'), this.formId);
            // set action if set on form
            if (this.controllerAction !== undefined && this.controllerAction != '') {
                action = this.controllerAction;
            }

            // add graphql query and args to body, add content type to header
            if (this.graphqlQuery !== undefined && this.graphqlQuery != '') {
                body.append(md5('graphqlQuery'), this.graphqlQuery);
            }
            if (this.graphqlQueryArgs !== undefined && this.graphqlQueryArgs != '') {
                body.append(md5('graphqlQueryArgs'), typeof this.graphqlQueryArgs === 'string' ? this.graphqlQueryArgs : JSON.stringify(this.graphqlQueryArgs));
            }

            const typeCast = Object.keys(this.typeCast).length ? JSON.stringify(this.typeCast) : ''
            body.append(md5('graphlQueryTypes'), typeCast)

            // let fields = this.inputSubmitHook(fields)

            const response = await fetch(action, {
                method: 'POST',
                headers,
                body
            });

            const json = await response.json();
            const {success, formErrors, generalErrors, redirectPath, queryResult} = json

            if (success === false) {

                this.errors = this.matchErrorsWithCustomMessages(formErrors ?? {});
                this.generalErrors = generalErrors ?? {};
                eventBus.$emit('formFail');
                if (redirectPath) {
                    window.location.href = redirectPath;
                }
            } else {
                this.errors = {};
                this.success = true;
                eventBus.$emit('formSuccess');

                //custom event will can be used in fronted
                const event = new CustomEvent('form_sent_successful', {detail: { webFormId: this.formId}});
                window.dispatchEvent(event);

                this.$emit('input-values', queryResult)

                if (this.callbackSuccess) {
                    this.callbackSuccess(json)
                    return
                }

                if (this.clearOnSuccess) {
                    this.formValues = {};
                    this.$refs.form.reset();
                }

                // redirect if url is in result
                if (redirectPath) {
                    setTimeout(() => {
                        window.location.href = redirectPath;
                    }, 3000);
                }
            }
        },
    }
};
</script>